import { Component } from '@angular/core';

@Component({
  selector: 'app-parent-communication',
  standalone: true,
  imports: [],
  templateUrl: './parent-communication.component.html',
  styleUrl: './parent-communication.component.css'
})
export class ParentCommunicationComponent {

}
